import { useDocumentationBrowserState } from 'components/documentation/DocumentationBrowser';

/** A documentation can be picked to take the file as its new version, even one without a current version. */
export function useExportToDocumentationBrowser(
  isOpen: boolean,
  selectableDocumentation: boolean
) {
  return useDocumentationBrowserState({
    isOpen,
    selectableDocumentation,
    requireDisplayedVersion: false,
  });
}
